import { FC, useEffect, useState } from "react";
import { Button } from "react-bootstrap";
import { PiPencilBold } from "react-icons/pi";
import FlexBox from "./flex-box";
import SimpleCard from "./simple-card";
import RawHTML from "./raw-html";
import SimpleModal from "./simple-modal";
import SimpleEditor from "./editor/simple-editor";
import SimpleButton from "./simple-button";

interface SimpleRichTextCardProps {
  isLoading?: boolean;
  label?: string;
  isEditable?: boolean;
  value: string;
  onContentChange?: (value: string) => void;
}

const SimpleRichTextCard: FC<SimpleRichTextCardProps> = ({
  isLoading,
  label,
  isEditable,
  value,
  onContentChange,
}) => {
  const [isShowModal, setIsShowModal] = useState<boolean>(false);
  const [content, setContent] = useState<string>(value);

  useEffect(() => {
    if (value?.localeCompare(content) !== 0) {
      setContent(value);
    }
  }, [value]);

  return (
    <>
      <SimpleCard
        title={label}
        isTitleNoBg
        action={
          isEditable && (
            <SimpleButton
              isLoading={isLoading}
              onClick={() => setIsShowModal(true)}
            >
              <FlexBox>
                <>Edit</> <PiPencilBold />
              </FlexBox>
            </SimpleButton>
          )
        }
      >
        <div className="mt-3">
          <RawHTML html={content} />
        </div>
      </SimpleCard>
      <SimpleModal
        size="lg"
        title={`Edit ${label}`}
        open={isShowModal}
        close={() => setIsShowModal(false)}
        footer={
          <Button
            variant="primary"
            onClick={() => {
              setIsShowModal(false);
              onContentChange?.(content);
            }}
          >
            Update
          </Button>
        }
      >
        <SimpleEditor
          value={content}
          onChange={setContent}
          className="mh-250 auto-scroll-250"
        />
      </SimpleModal>
    </>
  );
};

export default SimpleRichTextCard;
